import { LocationService } from '@/services/locationservice'

const state = {
  loading: false,
  dialog: false,
  overlay: false,
  province: [],
  city: [],
  district: []
}
const actions = {
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  },
  getProvince ({ commit }) {
    commit('setloading', true)
    LocationService.getProvince().then(value => {
      commit('setloading', false)
      commit('setprovince', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getCity ({ commit }, opt) {
    commit('setloading', true)
    LocationService.getCity(opt).then(value => {
      commit('setloading', false)
      commit('setcity', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getDistrict ({ commit }, opt) {
    commit('setloading', true)
    LocationService.getDistrict(opt).then(value => {
      commit('setloading', false)
      commit('setdistrict', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  }
}
const mutations = {
  setloading (state, s) {
    state.loading = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  setprovince (state, s) {
    state.province = []
    state.province = s.data
    state.loading = false
    state.overlay = false
  },
  setcity (state, s) {
    state.city = []
    state.city = s.data
    state.loading = false
    state.overlay = false
  },
  setdistrict (state, s) {
    state.district = []
    state.district = s.data
    state.loading = false
    state.overlay = false
  }
}

export const UtilsStore = {
  namespaced: true,
  state,
  actions,
  mutations
}
